(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_actions/poker-tournament-button/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/banner_actions/poker-tournament-button/assets/javascripts/init.js');
"use strict";


const {
  startPokerTournament,
  launchTournamentFromStorage
} = svs.components.poker.common.util;
const handleClick = node => {
  const {
    tournamentid,
    trackingString
  } = node.dataset;
  if (trackingString) {
    svs.components.analytics.trackEvent({
      category: 'Poker',
      action: 'initiate poker',
      opt_label: trackingString
    });
  }
  if (tournamentid) {
    startPokerTournament(tournamentid);
  }
};
const setupEventListener = () => {
  const nodes = document.querySelectorAll('.js-banner-actions-poker-tournament');
  nodes.forEach(node => {
    node.addEventListener('click', () => {
      handleClick(node);
    });
  });
};
const init = () => {
  setupEventListener();
  launchTournamentFromStorage();
};
init();

 })(window);